import * as React from 'react';
import './stepsBar.less';
import { Theme } from 'theme/types';
import { TranslationProps, WithCoreProps } from 'ff-shared-components-core';

export interface StepsBarProps {
	/**if you want to set new step values use this array , by default the step values are fetched on the translations */
	steps?: string[];
	/**sets the active step */
	currentStep: number;
}

interface InjectedProps extends TranslationProps {
	theme?: Theme;
}

function StepsBarFn(props: StepsBarProps & InjectedProps): JSX.Element {
	const {
		t,
		currentStep,
		steps = [t<string>('stepper.steps.step1'), t<string>('stepper.steps.step2'), t<string>('stepper.steps.step3')],
	} = props;
	const itemWidth: string = (100 / steps.length).toString() + '%';

	return (
		<div className="ds-stepsBar-container">
			<ul className="steps-list">
				{steps &&
					steps.map((step: any, index: number) => (
						<li
							key={index}
							className={`${index + 1 <= currentStep && 'active '}${index + 1 === currentStep &&
								' current'}`}
							style={{ width: itemWidth }}
						>
							<span className="step-number"></span>
							<span className="step-name">{step}</span>
						</li>
					))}
			</ul>
		</div>
	);
}

export const StepsBar = WithCoreProps<StepsBarProps>(StepsBarFn);
